module.exports = require("request");


/*****************
 ** WEBPACK FOOTER
 ** external "request"
 ** module id = 13
 ** module chunks = 0
 **/